import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import {
  newNextAction,
  NEW_NEXT,
} from '../../actions/navigation';
import Header from '../../components/Header';
import ContentWrapper from '../../components/ContentWrapper';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';
import Container from '../../components/Container';

// Configuration & Assets
import { useConfig } from '../../config/ConfigContext';
import iconACH from '../../assets/images/icon-ach.svg';
import iconCheck from '../../assets/images/icon-checkpayment.svg';
import './style.scss';

const LoanDetails = (props) => {
  const config = useConfig();
  const { checkinData, navigate, params, searchParams } = props;
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(false);
  const key = searchParams.get('key');

  useEffect(() => {
    const workflowType = get(params, 'workflowType');

    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  useEffect(() => {
    const { fetch } = props;

    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }
  }, [checkinData]);

  const handleButtonClick = (flag) => {
    const { dispatch } = props;
    const workflowType = get(params, 'workflowType') || 'text2apply';

    setIsProgressVisible(true);
    dispatch(newNextAction({
      key,
      workflowType,
      data: {
        manualMethod: flag,
      },
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    }));
  };

  return (
    <Transition className="transition-item wrapper manual-payment">
      <Header />
      <ContentWrapper className="ach-container">
        <Container className="container">
          <FormRow>
            <FormColumn className="col offset-1 alignCenter ach-page" offset={10}>
              <h1>ACH Auto-Pay Election</h1>
              <p>Enroll in optional ACH Auto-Pay for FREE and never miss a payment again.</p>
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn>
              <button type="button" onClick={() => { handleButtonClick('ach'); }} className="btn btn-outline">
                <FormRow>
                  <div className="col-auto">
                    <img src={iconACH} alt="" style={{ marginTop: '4px' }} />
                  </div>
                  <div className="col-auto">
                    <h5>Manually Enter ACH Info</h5>
                    <small>•&nbsp; Autopay &nbsp;•&nbsp; Free</small>
                  </div>
                </FormRow>
              </button>
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn>
              <button type="button" onClick={() => { handleButtonClick('check'); }} className="btn btn-outline">
                <FormRow>
                  <div className="col-auto">
                    <img src={iconCheck} alt="" />
                  </div>
                  <div className="col-auto">
                    <h5>Pay By Check</h5>
                    <small>Manual</small>
                  </div>
                </FormRow>
              </button>
            </FormColumn>
          </FormRow>
          <FormRow>
            <FormColumn className="eRegText">
              <p>Please Note: Enrolling in ACH Auto-Pay is optional. The Bank&apos;s credit decision is not dependent on whether you enroll in ACH Auto-Pay. You can change your method of payment at any time in the future.</p>
            </FormColumn>
          </FormRow>
        </Container>
      </ContentWrapper>
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </Transition>
  );
};

LoanDetails.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(LoanDetails);
